import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Text, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";
import { Sector } from "./Sector";

export class ThirdSector extends Sector {
    private static readonly SECTOR_TEXT = "LANDLORD";
    private static readonly SECTOR_ADDITIONAL_TEXT = "COMING SOON";
    private sectorAdditionalText: Text;

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super(unboardingResources.assets_views_unboarding_third_fragment_png, ThirdSector.SECTOR_TEXT, new SectorTextStyle());
        this.setSectorTextPosition(62, 61);
        this.sectorAdditionalText = new Text(ThirdSector.SECTOR_ADDITIONAL_TEXT, new SectorAdditionalTextStyle());
        this.sectorAdditionalText.position.set(82.5, 113);
        this.addChild(this.sectorAdditionalText);
    }
}

class SectorTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 62,
            fill: 'ffffff',
            letterSpacing: -1.55
        });
    }
}

class SectorAdditionalTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 34,
            fill: [
                "#fd7636",
                "#f62475"
            ],
            fillGradientType: 1
        });
    }
}